import { render, staticRenderFns } from "./mybankOrderShareRefundDetail.vue?vue&type=template&id=b70cf4aa&scoped=true"
import script from "./mybankOrderShareRefundDetail.vue?vue&type=script&lang=js"
export * from "./mybankOrderShareRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./mybankOrderShareRefundDetail.vue?vue&type=style&index=0&id=b70cf4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70cf4aa",
  null
  
)

export default component.exports